import { render, staticRenderFns } from "./AddNewCard.vue?vue&type=template&id=4c27fae3&"
import script from "./AddNewCard.vue?vue&type=script&lang=js&"
export * from "./AddNewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports